import { ScrollArea } from "@base-ui/react/scroll-area"
import React from "react"

import { Icon } from "shared/ui/icon/Icon"

import { GlobalSearchIconMap } from "features/global-search/lib/globalSearchIconMap"
import {
  GLOBAL_SEARCH_ALL_TAB,
  GlobalSearchOption,
  GlobalSearchResultType
} from "features/global-search/types/GlobalSearch"

import { useGlobalSearchContext } from "../../GlobalSearchContext"
import { GlobalSearchListbox } from "../GlobalSearchListbox"
import { GlobalSearchListItemFactory } from "../list-items/GlobalSearchListItemFactory"

interface IndexedItem {
  item: GlobalSearchOption
  index: number
}

interface IndexedGroup {
  type: GlobalSearchResultType
  label: string | undefined
  items: IndexedItem[]
}

export const GlobalSearchAllTab = React.memo(() => {
  const { options, activeTab } = useGlobalSearchContext()
  const isTabActive = activeTab === GLOBAL_SEARCH_ALL_TAB
  const groups = React.useMemo<IndexedGroup[]>(() => {
    let flatIndex = 0
    return Object.values(options).flatMap(group => {
      if (!group) return []
      return [
        {
          type: group.type,
          label: group.label,
          items: group.options.map(item => {
            const indexed = {
              item,
              index: flatIndex
            }
            flatIndex += 1
            return indexed
          })
        }
      ]
    })
  }, [options])

  return (
    <div className="global-search__tab-content global-search__all-tab">
      <ScrollArea.Root className="scroll-area scroll-area--vertical shadow-s global-search__scroll-area">
        <ScrollArea.Viewport className="scroll-area__viewport">
          <ScrollArea.Content className="scroll-area__content">
            <GlobalSearchListbox>
              {groups.map(group => (
                <div key={group.type} className="global-search__options-group">
                  <div className="global-search__options-group-header">
                    <Icon
                      name={GlobalSearchIconMap[group.type]}
                      className="global-search__options-group-icon"
                    />
                    <div className="global-search__options-group-title">
                      {group.label}
                    </div>
                  </div>
                  <div className="global-search__options-group-list">
                    {group.items.map(({ item, index }) => (
                      <GlobalSearchListItemFactory
                        key={item.id}
                        option={item}
                        index={index}
                        isTabActive={isTabActive}
                      />
                    ))}
                  </div>
                </div>
              ))}
            </GlobalSearchListbox>
          </ScrollArea.Content>
        </ScrollArea.Viewport>
        <ScrollArea.Scrollbar
          orientation="vertical"
          className="scroll-area__scrollbar"
        >
          <ScrollArea.Thumb className="scroll-area__thumb" />
        </ScrollArea.Scrollbar>
      </ScrollArea.Root>
    </div>
  )
})
